import { Route, Routes } from 'react-router-dom';
import { useEffect, useState, lazy } from 'react';
import './App.css';
// import Home from './pages/Home';
// import SRM_LOGIN from './pages/SRM_LOGIN';
// import LabelPage from './pages/LabelPage';

/* 로그인 + 기타 */
import AuthService from './service/AuthService';
import ProgressPage from './components/ProgressPage';

let loginInterval = null;
const Home = lazy(() => import('./pages/Home'))
const SRM_LOGIN = lazy (() => import('./pages/SRM_LOGIN'))
const LabelPage = lazy(() => import('./pages/LabelPage'))

function App() {
  const [inactive, setInactive] = useState(false);
  const modal = document.querySelector('#modal');
  const [tabMenuData, setTabMenuData] = useState([]);
  
  useEffect(() => {
    if(AuthService.checkLogin()) {
      loginInterval = setInterval(loginTimer, 1000);
    }
  }, []);

  useEffect(() => {
    modal.style.display = "none";
  })

  const loginTimer = () => {
    let startTime = parseInt(sessionStorage.getItem("start-time")) + 1;
    sessionStorage.setItem("start-time", startTime);
    const endTime = sessionStorage.getItem("end-time");
    // if(endTime < startTime) {
    //   alert("장시간 사용으로 로그아웃 되었습니다.");
    //   AuthService.logout();
    //   window.location.replace("/");
    //   clearInterval(loginInterval);
    // }
  }

  /**
   * Routes 를 사용할 경우 예전 방식 Route 에 exact 설정(해당 주소만 리랜더링)
   * 이 필요하지않고 자체적으로 해당 url 에 매핑 해준다. 
   */
  return (
      <div className={`myContainer ${inactive ? 'inactive' : ''}`}>
        <div className='myContainer-in-center' translate={'no'}>
          <ProgressPage></ProgressPage>        
          <Routes>
            <Route path="/*" element={AuthService.checkLogin() ? <Home/> : <SRM_LOGIN/>} />
            <Route path="/Login" element={AuthService.checkLogin() ? <Home/> : <SRM_LOGIN/>} />
            <Route path="/LabelPage" element={AuthService.checkLogin() ? <LabelPage/> : <SRM_LOGIN/>} />
            <Route path="/" element={AuthService.checkLogin() ? <Home/> : <SRM_LOGIN/>} />
          </Routes>
        </div>
      </div>
  );
}

export default App;
